import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import s from './CoreUpsellRow.scss';

interface Props {}

const CoreUpsellRow: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <tr className={s['core-upsell-row']}>
      <td colSpan={1000}>
        <div className={s['root']}>
          <div className={s['text']}>
            {t('studio.reports.section.topSellers.table.coreUpsell.text')}
          </div>
          <BrandedButton
            size="medium"
            variant="core-orange"
            href={Url.coreMembershipLink()}
            target="_blank"
            biData={BiData<BuyCoreButtonBiEvent>({
              evid: 375,
              referral_info: ReferralType.STUDIO_ANALYTICS,
            })}
          >
            {t('studio.reports.section.topSellers.table.coreUpsell.cta')}
          </BrandedButton>
        </div>
      </td>
    </tr>
  );
};
CoreUpsellRow.displayName = 'CoreUpsellRow';

export default CoreUpsellRow;
